import styled from "styled-components";

export const VacancyFinderContainer = styled.div`
  border-radius: 24px;
  padding: 24px;
  gap: 20px;
  max-width: 1200px;
  margin: 20px auto;
  margin-top: -160px;
  width: 100%;
  background: linear-gradient(135deg, #3393f0 10%, rgb(37, 105, 173) 80%);

  @media (max-width: 649px) {
    margin-top: -90px;
  }

  @media (max-width: 470px) {
    margin-top: -70px;
  }

  @media (max-width: 1224px) {
    width: 83%;
  }
`;

export const VacanyFinderTitle = styled.h1`
  margin: 20px 20px 20px 20px;
  color: white;
`;

export const VacancyFinderSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  margin-right: 20px;

  @media (max-width: 766px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const VacancyFinderSearchButton = styled.div`
  border-radius: 24px;
  background-color: #3393f0;
  width: 178px;
  padding: 12px 18px 12px 18px;
  margin-left: 20px;
  margin-bottom: 20px;
  color: white;
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

export const VacancyFinderRadiusField = styled.select`
  border-radius: 24px;
  border: none;
  padding: 12px;
  width: 10%;
  color: #54595f;

  @media (max-width: 766px) {
    width: 100%;
  }
`;

export const VacancyFinderLocationField = styled.input`
  border-radius: 24px;
  padding: 12px;
  width: 35%;
  border: none;
  color: #54595f;

  @media (max-width: 766px) {
    width: 100%;
  }
`;

export const VacancyFinderFunctionField = styled.input`
  border-radius: 24px;
  padding: 12px;
  width: 65%;
  border: none;
  color: #54595f;

  @media (max-width: 766px) {
    width: 100%;
  }
`;

export const VacancyFinderProvinceField = styled.select`
  border-radius: 24px;
  padding: 12px;
  width: 35%;
  border: none;
  color: #54595f;

  @media (max-width: 766px) {
    width: 100%;
  }
`;
